import { render, staticRenderFns } from "./paginations.vue?vue&type=template&id=af41b5b8&scoped=true&"
import script from "./paginations.vue?vue&type=script&lang=js&"
export * from "./paginations.vue?vue&type=script&lang=js&"
import style0 from "./paginations.vue?vue&type=style&index=0&id=af41b5b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af41b5b8",
  null
  
)

export default component.exports